import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FiDataFieldViewBase } from '../data-field-view-base';

@Component({
    selector: 'data-field-view-custom',
    templateUrl: './custom.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewCustomComponent extends FiDataFieldViewBase {}
